// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1d0744a5","453":"3c708060"}[chunkId] + ".chunk.js";
};